import React, { useEffect, useState } from "react";
import TopTitleBanner from "../component/TopTitleBanner";
import "../css/dashboard.css";
import "../css/setting.css";
import { useAuth } from "../contexts/AuthContext";
import "react-toastify/dist/ReactToastify.css";
import "react-tippy/dist/tippy.css";
import { roles } from "../firebase.collection";
import {
  documentId,
  onSnapshot,
  query,
  where,
  collection,
} from "firebase/firestore";
import { db } from "../firebase";
import FormLineMedium6 from "../component/FormLineMedium6";
import TitleMedium6 from "../component/Titles/TitleMedium6";

export default function StaffListContent() {
  const [allRoles, setAllRoles] = useState([]);
  const [userRole, setUserRole] = useState("");
  const { currentUser } = useAuth();

  const userIdState = currentUser ? currentUser.uid : "";

  useEffect(() => {
    const roleCollection = collection(db, "roles");
    const unsubscribe = onSnapshot(roleCollection, (querySnapshot) => {
      setAllRoles(
        querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
      );
    });
    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (currentUser) {
      queryRole();
    } else {
      console.log("No user id");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  function queryRole() {
    onSnapshot(
      query(roles, where(documentId(), "==", userIdState)),
      (querySnapshot) => {
        const doc = querySnapshot.docs[0];
        if (doc && doc.exists) {
          const role = doc.data().role;

          setUserRole(role);
        } else {
          console.log("No role for this user");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }
    );
  }

  const isSuperAdmin = userRole === "Super Admin";
  const isNormalUser = userRole === "Normal User";

  return (
    <div className="right-container-settings">
      {isSuperAdmin && !isNormalUser ? (
        <div className="admin-panel">
          <TopTitleBanner title={"Staff list content"} />

          <div style={{ paddingLeft: "25px" }}>
            <TitleMedium6 />

            {allRoles.map((role) => (
              <FormLineMedium6
                key={role.id}
                userId={role.id}
                userName={role.displayName}
                userRole={role.role}
                userPhone={role.phoneNumber}
                userEmail={role.userEmail}
              />
            ))}
          </div>
        </div>
      ) : (
        <div>
          <TopTitleBanner title={"Staff list content"} />
          <p style={{ marginLeft: "60px", color: "red", fontWeight: "bold " }}>
            --Normal User and Super-admin credentials cannot access this page--
          </p>
        </div>
      )}
    </div>
  );
}
